import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-600">最新章节实时同步，追漫不等待</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs text-accent-600 font-medium whitespace-nowrap">实时更新中</span>
          </div>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {latestUpdates.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className={`flex items-center gap-4 p-4 md:p-5 transition-colors duration-200 hover:bg-primary-50/50 cursor-pointer ${
                index < latestUpdates.length - 1 ? 'border-b border-background-100' : ''
              }`}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {comic.title}
                  </h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {comic.category}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1 truncate">
                  更新至第{comic.chapters}话 · {comic.author}
                </p>
              </div>

              <div className="flex-shrink-0 text-right">
                <p className="text-xs text-foreground-500 whitespace-nowrap">{comic.updatedAt}</p>
                <div className="flex items-center gap-1 justify-end mt-1">
                  <i className="ri-eye-line text-xs text-foreground-400"></i>
                  <span className="text-xs text-foreground-400">
                    {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
                  </span>
                </div>
              </div>

              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-foreground-400 text-lg"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}